import useModal from "@/src-refactor/modules/shared/components/refactor/base/modal/useModal";
import MxModalTemplate2 from "@rf-l1/modal/MxModalTemplate2";
import MxTypography from "@rf-l1/MxTypography";
import MxFormErrorMessage from "@rf-l2/form/MxFormErrorMessage";
import MxFormFieldController from "@rf-l2/form/MxFormFieldController";
import MxFormTextAreaField from "@rf-l2/form/text-fields/MxFormTextAreaField";
import MxButton2 from "@rf-l1/buttons/MxButton2";
import { useDeclineDocumentMutation } from "@/src-refactor/modules/store/qrtk/services/realestate/realestate.qrtk";
import { Grid } from "@mui/material";
import { useForm, FormProvider } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import toast from "react-hot-toast";
import { object, string } from "yup";

interface IOppositionCommentForm {
  comment: string;
}

const validationSchema = object().shape({
  comment: string()
    .min(5, "El mínimo es de 5 caracteres")
    .required("El comentario es requerido")
});

const OppositionCommentModal = () => {
  const [DECLINE_M] = useDeclineDocumentMutation();
  const { onConfirm, getData } = useModal();
  const data = getData() as any;

  const methods = useForm<IOppositionCommentForm>({
    resolver: yupResolver(validationSchema),
    defaultValues: {
      comment: ""
    },
    mode: "onChange"
  });

  const onSubmit = async (values: IOppositionCommentForm) => {
    const request = DECLINE_M({
      body: {
        validation_document_id: data?.id,
        comment: values.comment
      }
    }).unwrap();

    return toast
      .promise(request, {
        loading: "Enviando...",
        success: "Enviado",
        error: "Error al enviar"
      })
      .then(() => {
        onConfirm();
      });
  };

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onSubmit)}>
        <Grid container>
          <Grid item xs={12} justifyContent={"center"}>
            <MxTypography variant="caption" color="grey.600" fontWeight={400}>
              Escribir motivo de rechazo del documento {data?.document}
            </MxTypography>
          </Grid>
          <Grid item xs={12} justifyContent={"center"} my={2}>
            <Grid container>
              <Grid item xs={12}>
                <MxFormFieldController name="comment" withReactHookForm>
                  <MxFormTextAreaField
                    name="comment"
                    placeholder="Escriba un justificante"
                  />
                  <MxFormErrorMessage />
                </MxFormFieldController>
              </Grid>
              <Grid container item xs={12} justifyContent={"flex-end"} mt={2}>
                <MxButton2
                  type="submit"
                  variant="contained"
                  bgColor="primary.main"
                  textColor="white"
                  disabled={methods.formState.isSubmitting}
                  loading={methods.formState.isSubmitting}
                >
                  Enviar
                </MxButton2>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </form>
    </FormProvider>
  );
};

const useDeclineDocumentModal = () => {
  const { modal } = useModal();

  const declineDocument = (name: string, id: number) => {
    modal({
      template: <MxModalTemplate2 children={<OppositionCommentModal />} />,
      data: {
        document: name,
        id: id,
        title: "Comentario"
      },
      options: {
        size: {
          xs: { width: "100%", maxWidth: "100%" },
          sm: { width: "100%", maxWidth: "100%" },
          md: { width: "500px", maxWidth: "500px", minHeight: "300px" },
          lg: { width: "500px", maxWidth: "500px", minHeight: "300px" },
          xl: { width: "500px", maxWidth: "500px", minHeight: "300px" }
        }
      }
    });
  };
  return {
    declineDocument
  };
};

export default useDeclineDocumentModal;
